/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;align-items:center;height:100%}.sms-customer[_ngcontent-%COMP%]{border-bottom:1px dashed #a1a1a1}.disable-export-sale-operations[_ngcontent-%COMP%], .sms-customer[_ngcontent-%COMP%]{margin:20px 0;display:flex;width:100%;padding:5px}.disable-export-sale-operations[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .sms-customer[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:18px!important;padding-left:5px}"];
export { styles as styles };
